// =============================================================================
// ENUMS
// =============================================================================

export enum EAttributeType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  BOOL = 'BOOL',
  SELECTION = 'SELECTION',
  PLAIN = 'PLAIN',
}

export enum EAttributeUnitFamily {
  NONE = 'NONE',
  DISTANCE = 'DISTANCE',
  AREA = 'AREA',
  VOLUME = 'VOLUME',
  CURRENCY = 'CURRENCY',
  SOUND_PRESSURE = 'SOUND_PRESSURE',
  LUMINANCE = 'LUMINANCE',
  TEMPERATURE = 'TEMPERATURE',
  ANGLE = 'ANGLE',
  PERCENTAGE = 'PERCENTAGE',
  HUMIDITY = 'HUMIDITY',
  VELOCITY = 'VELOCITY',
  THERMAL_TRANSMITTANCE = 'THERMAL_TRANSMITTANCE',
  WEIGHT = 'WEIGHT',
  ENERGY = 'ENERGY',
}

export enum EAttributeUnit {
  // DISTANCE
  MM = 'MM',
  CM = 'CM',
  DM = 'DM',
  M = 'M',
  KM = 'KM',
  IN = 'IN',
  FT = 'FT',
  YD = 'YD',
  MI = 'MI',

  // AREA
  MM_2 = 'MM2',
  CM_2 = 'CM2',
  DM_2 = 'DM2',
  M_2 = 'M2',
  KM_2 = 'KM2',
  IN_2 = 'IN2',
  FT_2 = 'FT2',
  YD_2 = 'YD2',
  MI_2 = 'MI2',

  // VOLUME
  MM_3 = 'MM3',
  CM_3 = 'CM3',
  DM_3 = 'DM3',
  M_3 = 'M3',
  KM_3 = 'KM3',
  IN_3 = 'IN3',
  FT_3 = 'FT3',
  YD_3 = 'YD3',
  MI_3 = 'MI3',
  L = 'L',
  IMP_GAL = 'IMP_GAL',
  US_GAL = 'US_GAL',

  // CURRENCY
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  TRY = 'TRY',
  CHF = 'CHF',

  // SOUND & LIGHT
  DECIBEL = 'DB',
  CD_M2 = 'CD_M2',

  // TEMPERATURE
  TF = 'TF',
  TC = 'TC',

  // ANGLE
  DEGREE = 'DEGREE',

  // MISC
  PC = 'PC',
  G_M3 = 'G_M3',
  M_S = 'M_S',
  W_M2K = 'W_M2K',
  M2K_W = 'M2K_W',

  // WEIGHT
  MG = 'MG',
  G = 'G',
  KG = 'KG',
  T = 'T',
  OZ = 'OZ',
  LBS = 'LBS',
  ST = 'ST',
  LT = 'LT',

  // ENERGY
  KWH = 'KWH',
}

// =============================================================================
// SUB-INTERFACES
// =============================================================================

export interface IAttributeLocalization {
  cz?: string;
  de?: string;
  en?: string;
  es?: string;
  fr?: string;
  hr?: string;
  it?: string;
  ja?: string;
  nl?: string;
  pl?: string;
  pt?: string;
  ro?: string;
  rs?: string;
  ru?: string;
  tr?: string;
  [languageCode: string]: string | undefined;
}

export interface IDefaultValue {
  value?: string | number | null;
  unit?: string | null;
}

export interface IAttributeDefaults {
  DE?: IDefaultValue;
  CH?: IDefaultValue;
  GB?: IDefaultValue;
  US?: IDefaultValue;
  GLOBAL?: IDefaultValue;
  [regionCode: string]: IDefaultValue | undefined;
}

// Validation Interfaces
export interface INumberValidation {
  min?: number | null;
  max?: number | null;
  step?: number | null;
  precision?: number | null;
  unit?: string | null;
}

export interface ITextValidation {
  minLength?: number | null;
  maxLength?: number | null;
  pattern?: string | null;
}

export type TLocalizedSelectionValue = Record<string, string>;
export type TSelectionValue = string | TLocalizedSelectionValue;

export interface ISelectionValidation {
  values?: TSelectionValue[];
}

export interface IAttributeValidation {
  DE?: INumberValidation | ITextValidation | ISelectionValidation;
  CH?: INumberValidation | ITextValidation | ISelectionValidation;
  GB?: INumberValidation | ITextValidation | ISelectionValidation;
  US?: INumberValidation | ITextValidation | ISelectionValidation;
  GLOBAL?: INumberValidation | ITextValidation | ISelectionValidation;
  [regionCode: string]: any;
}
